import React from "react";
import loadingImageUrl from "../../assets/images/loading.svg";

function LoadingImage(props) {
  const { src } = props;
  const imgProps = { ...props, src: src || loadingImageUrl };

  return <img {...imgProps} alt={imgProps.alt || ""} />;
}

export default LoadingImage;
